import IconPhoneUser from "./icon-phone-user";

export default IconPhoneUser;